<template>
  <div :class="[{'container': !outside}]">
    <card :gradient="gradient"
          no-body
          shadow-size="lg"
          class="border-0">
        <div :class="[{'p-5': !outside}, {'container py-5': outside}]">
            <div class="row align-items-center">
                <div class="col-lg-8" :class="[{'order-lg-last': invert}]">
                    <h3 class="text-white text-center" :class="[{'text-lg-right': invert}, {'text-lg-left': !invert}]">{{title}}</h3>
                    <p class="lead text-white text-center mt-3" :class="[{'text-lg-right': invert}, {'text-lg-left': !invert}]">{{text}}</p>
                </div>
                <div class="col-lg-3" :class="[{'order-lg-first mr-lg-auto': invert}, {'ml-lg-auto': !invert}]">
                    <base-button tag="a" :href="buttonRoute"
                                 type="white" block size="lg">
                        {{buttonTitle}}
                    </base-button>
                </div>
            </div>
        </div>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card';

export default {
  name: "callToAction",
  components: {
    Card,
  },
  props: {
    outside: {
      type: Boolean,
      default: false,
      description: "se definida, cria um container dentro do card (para utilização fora do container principal do site)"
    },
    invert: {
      type: Boolean,
      default: false,
      description: "se definida, muda a ordem do texto e do botão (esquerda-direita)"
    },
    gradient: {
      type: String,
      default: "default",
      description: "default|primary|secondary|info|success|danger|warning"
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    buttonTitle: {
      type: String,
      default: ""
    },
    buttonRoute: {
      type: String,
      default: ""
    }
  },
};
</script>
<style>
</style>
